import React, { useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../../../common/breadcrumbs";
import { useTranslation } from "react-i18next";
import {
  INPUT_LENGTH_15,
  SWAL_SETTINGS,
} from "../../../../../../utils/Constants";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../../../utils/customError";
import { AddTestimonial } from "../../../../services/usermgmt.services";
import { Tooltip, Whisper } from "rsuite";

const CentreTestimonialAdd = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [previewimage, setPreviewImage] = useState("");
  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    {
      title: t("Center Management"),
      url: "/admin/center-management/center/list/1",
    },
    {
      title: t("Center Testimonials"),
      url: `/admin/center-management/center/testimonial/${params.center_id}/list/1`,
    },
    { title: t("admin.cafes.link_add"), url: "" },
  ];

  const validationSchema = Yup.object().shape({
    name: Yup.string().trim().required("Name is required"),
    testimonial_text: Yup.string().required("Testimonial text is required"),
    profile_image: Yup.mixed()
      .nullable()
      .test(
        'fileType',
        'admin.cafes.supported_file_error',
        value => !value || ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(value.type)
      )
      .test(
        'fileSize',
        'admin.cafes.image_max_size_error',
        value => !value || value.size <= 1.5 * 1024 * 1024
      )
      .test(
        'validImage',
        'Upload a valid image',
        value =>
          new Promise(resolve => {
            if (!value || typeof value === 'string') return resolve(true);

            const reader = new FileReader();
            reader.onload = () => {
              const img = new Image();
              img.onload = () => resolve(true);
              img.onerror = () => resolve(false);
              img.src = reader.result;
            };
            reader.onerror = () => resolve(false);
            reader.readAsDataURL(value);
          })
      ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      testimonial_text: "",
      profile_image: "",
      center_id: params.center_id,
    },
    validateOnBlur: false,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      globalLoader(true);
      setSubmitted(true);
      let formData = new FormData();
      formData.append("name", values.name);
      formData.append("center_id", values.center_id);
      formData.append("testimonial_text", values.testimonial_text);
      formData.append("profile_image", values.profile_image);

      AddTestimonial(formData)
        .then((response) => {
          setSubmitting(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            resetForm({ values: "" });
            navigate(`/admin/center-management/center/testimonial/${params.center_id}/list/1`);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            setSubmitted(false);
          }
        })
        .catch((error) => {
          console.log("error ====> ", error);
        });
    },
  });

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={formik.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                <div>
                  <h6 className="main-content-label mb-3">
                    Add Testimonial
                  </h6>
                </div>
                <div className="row row-sm">


                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="name" className="text-left d-flex">
                      {t("Name")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="name"
                      id="name"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      className="form-control"
                      placeholder={t("Enter name")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError shortCodes={[INPUT_LENGTH_15]} name="name" form={formik} />
                    </span>
                    {/* <span>DT(t(form.errror), [])</span> */}
                  </div>

                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="testimonial_text" className="text-left d-flex">
                      Testimonial Text:<span className="requirestar">*</span>{" "}
                    </label>
                    <textarea
                      name="testimonial_text"
                      id="testimonial_text"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.testimonial_text}
                      className="form-control"
                      placeholder="Enter testimonial text"
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="testimonial_text" form={formik} />
                    </span>
                  </div>
                 
                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="profile_image" className="text-left d-flex">
                      {t("admin.cafes.label_logo")}:
                      {" "}
                      <Whisper
                        placement="top"
                        controlId="control-id-hover"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            {t("admin.cafes.image_support_tooltip")}
                          </Tooltip>
                        }
                      >
                        <span className="field-more-info mt-1 ms-1 cp">
                          ?
                        </span>
                      </Whisper>
                    </label>
                    <input
                      className="form-control imgInput"
                      id="profile_image"
                      name="profile_image"
                      accept="image/*"
                      type="file"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "profile_image",
                          event.target.files[0] || ""
                        );
                        event.target.files.length === 1
                          ? setPreviewImage(
                            URL.createObjectURL(event.target.files[0])
                          )
                          : setPreviewImage("");
                      }}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="profile_image" form={formik} />
                    </span>

                    {previewimage ? (
                      <ul className="question-image-preview questions-ul">
                        <li className="pr_img_box">
                          <img
                            src={previewimage}
                            style={{ height: "100px" }}
                            alt={"Profile_Img"}
                          />
                          <div className="img_options">
                            <button type="button" className="text-danger"
                              onClick={() => {
                                // console.log(previewResImage , previewimage)
                                setPreviewImage("");
                                formik.setFieldValue("profile_image", null);
                                document.getElementById("profile_image").value = ""
                              }}>
                              <i className="ri-delete-bin-6-fill"></i>
                            </button>
                          </div>
                        </li>
                      </ul>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="mt-5">
                    <button
                      className="btn btn-info mr-2"
                      type="submit"
                      disabled={submitted ? true : null}
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("admin.button.btn_submit")}
                    </button>
                    <button
                      className="btn ripple btn-secondary"
                      type="button"
                      disabled={submitted ? true : null}
                      onClick={() => navigate(-1)}
                    >
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("admin.button.btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default CentreTestimonialAdd;